import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../../../../app/parkifly-bookings/organizations/features/booking/components/form/service';
import { FormControl } from '@angular/forms';
import { format } from 'date-fns';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../../../app/services/auth.service';
import { WelcomeComponent } from '../../../components/welcome/welcome.component';
import { BookingConfigService } from '../../../../../app/parkifly-bookings/services/booking-config.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-simple-widget',
  standalone: false,
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FormService]
})
export class SimpleWidgetComponent {
  site: string = '';
  parkingStartTime: any;
  parkingEndTime: any;
  discountCodeControl = new FormControl('');
  flightTimeWarning = false;
  org: string = "skavsta";
  currentLang: string = 'sv';

  constructor(
    private router: Router,
    private _formService: FormService,
    private dialog: MatDialog,
    private authService: AuthService,
    private route: ActivatedRoute,
    private bookingConfigService: BookingConfigService,
    private translate: TranslocoService
  ) {
    this.site = "skavsta";
    this._formService.initForm(this.site);
    this.currentLang = this.translate.getActiveLang();
  }

  ngOnInit(): void {

    // localStorage.setItem('navigation_organization', 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B');
    // localStorage.setItem('selectedOrganization', 'skavsta');

    this.route.queryParams.subscribe(params => {
      let orgId = params['orgId'] || 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B';
      switch (orgId) {
        case 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B':
          this.org = "skavsta";
          localStorage.setItem('navigation_organization', 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B');
          localStorage.setItem('selectedOrganization', 'skavsta');
          this.bookingConfigService.setOrganization("skavsta");
          break;
        default:
          this.org = "skavsta";
          localStorage.setItem('navigation_organization', 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B');
          localStorage.setItem('selectedOrganization', 'skavsta');
          this.bookingConfigService.setOrganization("skavsta");
      }
    });

    const search = this._formService.getForm().get('search');

    search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.parkingEndTime = value;
    })
    search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.parkingStartTime = value;
    })
  }

  get isContinueButtonEnabled(): boolean {
    return this.parkingStartTime && this.parkingEndTime && this.parkingEndTime > this.parkingStartTime
  }

  goToBookingForm() {

    this.navigateToBooking();

    // if (this.authService.loggedIn()) {
    //   this.navigateToBooking();
    // } else {
    //   const dialogRef = this.dialog.open(WelcomeComponent, {
    //     width: '500px',
    //     disableClose: false,
    //     panelClass: 'welcome-dialog'
    //   });

    //   dialogRef.afterClosed().subscribe(() => {
    //     this.navigateToBooking();
    //   });
    // }
  }

  navigateToBooking() {
    const search = this._formService.getForm().get('search');
    let parking_start = format(this.parkingStartTime, 'yyyy-MM-dd HH:mm')
    let parking_end = format(this.parkingEndTime, 'yyyy-MM-dd HH:mm')
    let queryParams: any = {
      parking_start: parking_start || undefined,
      parking_end: parking_end || undefined,
    };
    if (this.discountCodeControl.value.length) {
      queryParams['discount_code'] = this.discountCodeControl.value;
    }

    const urlTree = this.router.createUrlTree(
      ['parkifly', this.org, 'booking', {
        parking_start: parking_start,
        parking_end: parking_end,
        discount_code: this.discountCodeControl.value ?? 'NONE'
      }]
    );

    const relativeUrl = this.router.serializeUrl(urlTree);
    const fullUrl = window.location.origin + relativeUrl;
    window.open(fullUrl, '_blank');
  }

  setLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.setActiveLang(lang);
  }

}
